(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-v2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const summary = event.target.closest('.footer-v2__accordion-summary[for]');

    if (!summary) return;

    const input = document.getElementById(summary.getAttribute('for'));

    if (!(input instanceof HTMLInputElement) || input.type !== 'radio' || !input.checked) return;

    event.preventDefault();
    input.checked = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-ingredients-slider]';
    const instances = new WeakMap();
    let splideLoader;

    function ensureSplide(slider) {
      if (window.Splide) return Promise.resolve();
      if (splideLoader) return splideLoader;

      const src = slider.dataset.splideScript;

      splideLoader = new Promise((resolve, reject) => {
        const absoluteSrc = new URL(src, window.location.href).href;
        const existingScript = Array.from(document.scripts).find((script) => script.src === absoluteSrc);
        const script = existingScript || document.createElement('script');

        script.addEventListener('load', resolve, { once: true });
        script.addEventListener('error', reject, { once: true });

        window.setTimeout(() => {
          if (window.Splide) resolve();
        });

        if (!existingScript) {
          script.src = src;
          script.defer = true;
          document.head.appendChild(script);
        }
      });

      return splideLoader;
    }

    function removeCloneEditorAttributes(slider) {
      slider.querySelectorAll('.splide__slide--clone [data-shopify-editor-block]').forEach((element) => {
        Array.from(element.attributes).forEach((attribute) => {
          if (attribute.name.startsWith('data-shopify')) {
            element.removeAttribute(attribute.name);
          }
        });
      });
    }

    function createContinuousAutoScrollExtension(enabled) {
      return function ContinuousAutoScroll(splide, Components, options) {
        const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        const root = splide.root;
        const speed = Number(options.continuousAutoScrollSpeed) || 0;
        const listeners = [];
        let animationFrame;
        let lastTime;
        let isHovered = false;
        let hasFocus = false;
        let isInteracting = false;

        function addListener(target, eventName, handler, eventOptions) {
          target.addEventListener(eventName, handler, eventOptions);
          listeners.push([target, eventName, handler, eventOptions]);
        }

        function canMove() {
          const states = window.Splide?.STATES;
          const isIdle = !states || splide.state.is(states.IDLE);

          return enabled && speed > 0 && isIdle && !reducedMotionQuery.matches && !isHovered && !hasFocus && !isInteracting;
        }

        function tick(timestamp) {
          if (!lastTime) lastTime = timestamp;

          const delta = timestamp - lastTime;
          lastTime = timestamp;

          if (canMove()) {
            const position = Components.Move.getPosition() - (speed * delta) / 1000;

            Components.Move.translate(Components.Move.shift(position));
          }

          animationFrame = window.requestAnimationFrame(tick);
        }

        function pauseForInteraction() {
          isInteracting = true;
        }

        return {
          mount() {
            if (!enabled) return;

            addListener(root, 'mouseenter', () => {
              isHovered = true;
            });

            addListener(root, 'mouseleave', () => {
              isHovered = false;
              lastTime = null;
            });

            addListener(root, 'focusin', () => {
              hasFocus = true;
            });

            addListener(root, 'focusout', () => {
              hasFocus = root.contains(document.activeElement);
              lastTime = null;
            });

            addListener(root, 'mousedown', pauseForInteraction);
            addListener(root, 'touchstart', pauseForInteraction, { passive: true });
            addListener(root, 'keydown', pauseForInteraction);

            if (reducedMotionQuery.addEventListener) {
              addListener(reducedMotionQuery, 'change', () => {
                lastTime = null;
              });
            }

            splide.on('drag', pauseForInteraction);

            animationFrame = window.requestAnimationFrame(tick);
          },

          destroy() {
            window.cancelAnimationFrame(animationFrame);

            listeners.forEach(([target, eventName, handler, eventOptions]) => {
              target.removeEventListener(eventName, handler, eventOptions);
            });
          },
        };
      };
    }

    function initSlider(slider) {
      if (instances.has(slider)) return;

      if (!window.Splide) {
        ensureSplide(slider).then(() => initSlider(slider)).catch(() => {});
        return;
      }

      const slideCount = Number(slider.dataset.slideCount) || 0;
      const isLoop = slideCount > 1;
      const splide = new window.Splide(slider, {
        type: isLoop ? 'loop' : 'slide',
        autoWidth: true,
        gap: 'var(--ingredients-slider-gap)',
        padding: {
          left: 'var(--ingredients-slider-gutter)',
          right: 'var(--ingredients-slider-gutter)',
        },
        arrows: false,
        pagination: false,
        drag: isLoop,
        clones: Math.max(slideCount, 4),
        focus: 0,
        trimSpace: false,
        speed: 600,
        updateOnMove: true,
        continuousAutoScrollSpeed: 36,
      });

      splide.on('mounted refresh updated', () => {
        removeCloneEditorAttributes(slider);
      });

      splide.mount({
        ContinuousAutoScroll: createContinuousAutoScrollExtension(isLoop),
      });
      instances.set(slider, splide);
    }

    function initSliders(root = document) {
      const sliders = root.matches?.(selector) ? [root] : Array.from(root.querySelectorAll(selector));

      sliders.forEach((slider) => {
        initSlider(slider);
      });
    }

    function destroySliders(root) {
      const sliders = root.matches?.(selector) ? [root] : Array.from(root.querySelectorAll(selector));

      sliders.forEach((slider) => {
        const splide = instances.get(slider);

        if (!splide) return;

        splide.destroy(true);
        instances.delete(slider);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initSliders());
    } else {
      initSliders();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initSliders(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      destroySliders(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-benefits-timeline"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pdpBenefitsTimelineSelector = '.pdp-benefits-timeline';
    const pdpBenefitsTimelineItemSelector = '.pdp-benefits-timeline__item';

    function revealPdpBenefitsTimelineItem(item) {
      item.classList.add('is-visible');
    }

    function initPdpBenefitsTimeline(root) {
      const timelines = root.querySelectorAll(pdpBenefitsTimelineSelector);

      timelines.forEach((timeline) => {
        const items = timeline.querySelectorAll(pdpBenefitsTimelineItemSelector);

        if (!items.length) return;

        if (!('IntersectionObserver' in window)) {
          items.forEach(revealPdpBenefitsTimelineItem);
          return;
        }

        const observer = new IntersectionObserver(
          (entries, timelineObserver) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              revealPdpBenefitsTimelineItem(entry.target);
              timelineObserver.unobserve(entry.target);
            });
          },
          {
            rootMargin: '0px 0px -18% 0px',
            threshold: 0.32,
          }
        );

        items.forEach((item) => {
          if (item.classList.contains('is-observed')) return;

          item.classList.add('is-observed');
          observer.observe(item);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initPdpBenefitsTimeline(document));
    } else {
      initPdpBenefitsTimeline(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initPdpBenefitsTimeline(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-pregnancy-plus"] && !Shopify.designMode) return;
  try {
    
  class PdpVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('.pdp-duo__play');
      if (this.button) this.button.addEventListener('click', () => this.play());
      if (this.video) {
        this.video.addEventListener('play', () => {
          this.dataset.playing = '';
          this.video.setAttribute('controls', '');
        });
      }
    }

    play() {
      if (!this.video) return;
      this.video.setAttribute('controls', '');
      const p = this.video.play();
      if (p && p.catch) p.catch(() => {});
    }
  }

  if (!customElements.get('pdp-video')) {
    customElements.define('pdp-video', PdpVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  class PdpReviews extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-reviews-track]');
      this.progress = this.querySelector('[data-reviews-progress]');
      this.filters = Array.from(this.querySelectorAll('.pdp-reviews__filter'));
      this.cards = Array.from(this.querySelectorAll('.pdp-reviews__card'));

      this.filters.forEach((btn) => btn.addEventListener('click', () => this.applyFilter(btn)));

      if (this.track) {
        this.track.addEventListener('scroll', () => this.updateProgress(), { passive: true });
        window.addEventListener('resize', () => this.updateProgress());
      }
      this.updateProgress();
    }

    applyFilter(btn) {
      const filter = btn.dataset.filter;
      this.filters.forEach((f) => {
        const active = f === btn;
        f.classList.toggle('is-active', active);
        f.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      this.cards.forEach((card) => {
        const trimester = card.dataset.trimester;
        const show = filter === '__all__' || trimester === filter || trimester === '__all__';
        card.toggleAttribute('hidden', !show);
      });

      if (this.track) this.track.scrollLeft = 0;
      this.updateProgress();
    }

    updateProgress() {
      if (!this.track || !this.progress) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      const ratio = max > 0 ? this.track.scrollLeft / max : 0;
      this.progress.style.width = `${ratio * 100}%`;
    }
  }

  if (!customElements.get('pdp-reviews')) {
    customElements.define('pdp-reviews', PdpReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-stages"] && !Shopify.designMode) return;
  try {
    
  class PdpStages extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.pdp-stages__item'));
      this.mediaItems = Array.from(this.querySelectorAll('.pdp-stages__media-item'));

      this.items.forEach((item) => {
        const trigger = item.querySelector('.pdp-stages__trigger');
        trigger.addEventListener('click', () => this.toggle(item));
      });
    }

    toggle(item) {
      const isOpen = item.dataset.open === 'true';
      const index = item.dataset.stageIndex;

      this.items.forEach((el) => {
        const open = el === item && !isOpen;
        el.dataset.open = open ? 'true' : 'false';
        const trigger = el.querySelector('.pdp-stages__trigger');
        if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      // Keep the desktop media in sync with the most recently opened stage.
      if (!isOpen) this.setActiveMedia(index);
    }

    setActiveMedia(index) {
      this.mediaItems.forEach((el) => {
        el.dataset.active = el.dataset.mediaIndex === index ? 'true' : 'false';
      });
    }
  }

  if (!customElements.get('pdp-stages')) {
    customElements.define('pdp-stages', PdpStages);
  }

  } catch(e) { console.error(e); }
})();
})();
